export const MOCK_FUNCTIONAL_ROLE = {
  id: 1,
  name: 'Technical Property Manager',
}

export const MOCK_FUNCTIONAL_ROLE_OPTIONS = [
  { label: 'Technical Property Manager', value: 1 },
  { label: 'KPM', value: 2 },
  { label: 'Accounting Manager', value: 3 },
  { label: 'Service Manager', value: 4 },
]

export const QA_NAME_PROFILE_FUNCTIONAL_ROLE_MODAL_USER_STAFF_OPEN_BTN =
  'libraryStaffFunctionalRoleModalOpenBtn'
